import { gql, useQuery } from '@apollo/client';
import { get } from 'lodash';

const getWebshopAvailabilityQuery = gql`
query getWebshopAvailabilityQuery($jobName: String!) {
  webshopAvailability(jobName: $jobName)
}
`;

const useWebshopAvailability = ({ jobName }) => {
  const { data } = useQuery(getWebshopAvailabilityQuery, {
    variables: {
      jobName
    },
    fetchPolicy: 'cache-and-network'
  });

  const isWebshopAvailable = get(data, 'webshopAvailability');

  return { isWebshopAvailable };
};

export default useWebshopAvailability;
